import { render, staticRenderFns } from "./CategoryHeader.vue?vue&type=template&id=15b1bdce&scoped=true&"
import script from "./CategoryHeader.vue?vue&type=script&lang=js&"
export * from "./CategoryHeader.vue?vue&type=script&lang=js&"
import style0 from "./CategoryHeader.vue?vue&type=style&index=0&id=15b1bdce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b1bdce",
  null
  
)

export default component.exports